<template>
  <page>
    <template slot="content">
      <q-and-a-content :title="'ログインアカウントを変更する'">
        <template slot="content">
          <div class="text">メニューの<b>アカウント</b>にて変更することが可能です。ここに表示されているEメールまたは携帯番号がログインアカウントになります。</div>
          <img class="picture" src="../assets/images/q_and_a/4.png">
          <!-- <img class="picture" src="../assets/images/q_and_a/5.png"> -->
        </template>
      </q-and-a-content>
    </template>
  </page>
</template>

<script>
  import Page from '@/components/Page'
  import QAndAContent from '@/components/QAndAContent.vue'

  export default {
    name: 'QAndABindingAccount',
    components: {
      Page,
      QAndAContent
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/FeaturesBindingAccount.vue